// extracted by mini-css-extract-plugin
export var errorBanner = "_ca-2";
export var scroller = "_ca-0";
export var thinking = "_ca-1";
export var visuallyHidden = "_ca-3";